import {NavLink, useLocation} from 'react-router-dom';
import CustomIcon from './CustomIcon'


const NavLi = ({title, to, iconName, classes, path = [], ...props}) => {

  const activeClassName = "flex items-center gap-4 text-sm text-gray-700 font-light px-4 py-2.5 rounded-lg hover:bg-gray-100 bg-gradient-to-tr nav-gradient shadow-md color-white"
  const inActiveClassName = "flex items-center gap-4 text-sm text-gray-700 font-light px-4 py-2.5 rounded-lg hover:bg-gray-100"
  const location = useLocation()

  const isActive = location.pathname.replace(/^\/([^\/]*).*$/, '$1') === to.replace(/^\/([^\/]*).*$/, '$1')

  return (
    <li className={`rounded-lg mb-2${classes ? ` ${classes}` : ''}`} {...props}>
      <NavLink
        to={to}
        end
        className={isActive? activeClassName : inActiveClassName}
        // isActive={() => [to, ...path].includes(pathname)}
      >
        <CustomIcon icon={iconName} size="xl"/>
        {title}
      </NavLink>
    </li>
  )
}

export default NavLi
